import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
defineLocale('pt-br', ptBrLocale);

import { ROUTES } from './app.routes';
import { AppComponent } from './app.component';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { AuthService } from './shared/services/auth.service';
import { EventSharedService } from './shared/services/event-shared.service';

// Home module
import { HomeModule } from './modules/home/home.module';

// App modules/components
import { CoreModule } from './core/core.module';
import { InscricoesModule } from './modules/inscricoes/inscricoes.module';
import { ProjetoCompletoModule } from './modules/projeto-completo/projeto-completo.module';
import { StorageService } from './shared/services/storage.service';
import { QrObrasModule } from './modules/qr-obras/qr-obras.module';
import { PreProjetoModule } from './modules/pre-projeto/pre-projeto.module';
import { TutorialModule } from './modules/tutorial/tutorial.module';
import { ReuniaoModule } from './modules/reuniao/reuniao.module';
import { ChatBotModule } from './modules/chat-bot/chat-bot.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    CoreModule,
    HomeModule,
    InscricoesModule,
    ProjetoCompletoModule,
    QrObrasModule,
    PreProjetoModule,
    TutorialModule,
    ReuniaoModule,
    ChatBotModule,
    SharedModule,
    RouterModule.forRoot(ROUTES, {
      // utilizando paramsInheritanceStrategy = always, todos os
      // parametros das rotas 'pais' podem ser acessados em uma rota filha.
      // paramsInheritanceStrategy: 'always',
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 8000,
      closeButton: true,
      preventDuplicates: true,
    }),
  ],
  providers: [
    EventSharedService,
    AuthService,
    StorageService,
    GlobalErrorHandlerService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
